import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                {/* <InputGroup.Text id="basic-addon1">
                    <i className="fa fa-search"></i>
                </InputGroup.Text> */}
                <Form.Control size="sm" type="text" placeholder="Search" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/crypto/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "price",
        text: "Price",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
    },
    {
        dataField: "changesPercentage",
        text: "Change %",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "volume",
        text: "Volume",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    }
];

const columns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/crypto/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "name",
        text: "Name",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "price",
        text: "Price",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
    },
    {
        dataField: "changesPercentage",
        text: "Change %",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "dayLow",
        text: "Low",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false
    },
    {
        dataField: "dayHigh",
        text: "High",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false
    },
    {
        dataField: "open",
        text: "Open",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false
    },
    {
        dataField: "volume",
        text: "Volume",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    }
];

const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.changesPercentage > 0) {
        style.backgroundColor = '#99cc99';
    } else {
        style.color = 'red';
    }
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class CryptoListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cryptoList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 1); //1 mins
        this.getData();
    }

    changeHidden = () => {
        let screenWidth = window.screen.width;
        const newColumns = this.state.columns.map((column) => {
            if (screenWidth < 500) {
                if (column.dataField === 'name' || column.dataField === 'dayLow' || column.dataField === 'dayHigh' || column.dataField === 'open') {
                    column.hidden = true;
                }
            } else {
                column.hidden = false;
            }
            return column;
        });
        this.setState({ columns: newColumns, reload: true });
    }

    getData() {
        //this.changeHidden();
        ApiService.getAllQuotesCrypto()
            .then(allQuoteResult => {
                console.log('getAllQuoteCrypto', allQuoteResult);
                if (allQuoteResult !== undefined && allQuoteResult.length > 0) {
                    allQuoteResult.sort(this.custom_sort);
                    this.setState({ cryptoList: allQuoteResult, reload: true });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    custom_sort(a, b) {
        if (a.volume > b.volume) { return -1; }
        if (a.volume < b.volume) { return 1; }
        return 0;
    }

    render() {
        // if (this.state.reload) {
        //     console.log('CryptoListDisplay Reloading...');
        //     this.setState({ reload: false });
        //     return (<div>Loading...</div>);
        // }
        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.cryptoList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.cryptoList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default CryptoListDisplay;
